// Todo: Copy Paste from other template :D Please fix someday
export const exoClickTemplateDataId = "exoclick-before-pagination-sol"
export const exoClickBeforePaginationHtmlMobile = `<section id="page-top-sol" class="page-stripe page-stripe-page-top-sol page-stripe-content-exoclick-mobile no-solads-label extra-top-spacing" data-exoclick-id="${exoClickTemplateDataId}">
    <div class="container">
        <div class="row-page-actions-sol base-row row">
            <div class="sol-content uncensored-banner relative text-left content-width-320">
                <div class="sol-advert-mark">
                    <span class="sol-label"><a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a></span>
                    <small class="sol-text-label">Anzeige</small>
                </div>

                <div class="sol-frame sol-type-display uncensored-banner-container" >
                    <script async="async" type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                    <ins class="eas6a97888e" data-zoneid="5040788"></ins>
                    <span class="separator"> </span>
                    <script>(AdProvider = window.AdProvider || []).push({"serve": {}});</script>
                </div>
            </div>
        </div>
    </div>
</section>`

export const exoClickBeforePaginationHtmlPc =
    () => `<div class="col-xs-12 page-stripe-exoclick-pagination" data-exoclick-id="${exoClickTemplateDataId}">
    <div class="item clearfix text-left">
        <div class="sol-content uncensored-banner relative col-xs-12 content-width-240">
            <div class="sol-advert-mark">
                <span class="sol-label">
                    <a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a>
                </span>
                <small class="sol-text-label">Anzeige</small>
            </div>
            <div class="sol-frame sol-type-display uncensored-banner-container" data-columns="2">
                <script async type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                <ins class="eas6a97888e" data-zoneid="5040790"></ins>
                <span class="separator">&nbsp;</span>
                <script>(AdProvider = window.AdProvider || []).push({ "serve": {} }); </script>
            </div>
        </div>
    </div>
</div>`

export const exoClickBottomPc = `<section id="exoclick-bottom" class="page-stripe page-stripe-content-solads page-stripe-content-exoclick white no-top-spacing no-bottom-spacing exoclick-bottom">
    <div class="container">
        <div class="row">
                <div class="row service-sol">
                    <div class="sol-content uncensored-banner col-xs-12">
                        <div class="sol-advert-mark">
                            <span class="sol-label"><a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a></span>
                            <small class="sol-text-label">Anzeige</small>
                        </div>

                        <div class="sol-frame sol-type-display uncensored-banner-container" >
                            <script async="async" type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                            <ins class="eas6a97888e" data-zoneid="5040790"></ins>
                            <span class="separator"> </span>
                            <script>(AdProvider = window.AdProvider || []).push({"serve": {}});</script>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>`
